import { IPresenterProps } from './types';
import AuthLayout from '../../components/AuthLayout/Container';
import Navbar from '../../components/NavBar2/Container';
import Step1 from '../../components/LoginSteps/LoginStep1/Container';
import Step2 from '../../components/LoginSteps/LoginStep2/Container';
import Step3 from '../../components/LoginSteps/LoginStep3/Container';
import Step4 from '../../components/LoginSteps/LoginStep4/Container';
import { LOGIN_STEPS } from '../../utils/constants';

const LoginContainer = (props: IPresenterProps) => {

    return (
        <>
            <Navbar isSearchBarHidden={true} />
            <AuthLayout title={props.pageTitle}>

                {props.currentStep === LOGIN_STEPS.STEP_1 &&
                    <Step1
                        formData={props.formData}
                        loaderVisible={props.loaderVisible}
                        onChange={props.onChange}
                        actionBtn={props.actionBtn}
                        errorMessage={props.errorMessage}
                        emailIcon={props.emailIcon}
                        passwordIcon={props.passwordIcon}
                        passwordDisabled={props.passwordDisabled}
                        emailDisabled={props.emailDisabled}
                        pageTitle={props.pageTitle}
                        currentStep={props.currentStep}
                        changeStep={props.changeStep}
                    />
                }

                {/* EMAIL TO RECOVER PASSWORD */}
                {props.currentStep === LOGIN_STEPS.STEP_2 &&
                    <Step2
                        formData={props.formData}
                        loaderVisible={props.loaderVisible}
                        onChange={props.onChange}
                        actionBtn={props.actionBtn}
                        errorMessage={props.errorMessage}
                        emailIcon={props.emailForgotPasswordIcon}
                        emailDisabled={props.emailDisabled}
                        pageTitle={props.pageTitle}
                        currentStep={props.currentStep}
                        changeStep={props.changeStep}
                        messageError={props.messageErrorStep2}
                        sendCodeDisabledBtn={props.sendCodeDisabledBtn}
                        deleteInputText={props.deleteInputText}
                    />
                }

                {/* VALIDATE CODE */}
                {props.currentStep === LOGIN_STEPS.STEP_3 &&
                    <Step3
                        formData={props.formData}
                        loaderVisible={props.loaderVisible}
                        actionBtn={props.actionBtn}
                        errorMessage={props.errorMessage}
                        pageTitle={props.pageTitle}
                        currentStep={props.currentStep}
                        changeStep={props.changeStep}
                        messageErrorText={'Wrong code, try again.'}
                        messageError={props.messageError}
                        verificationCode={props.verificationCode}
                        verificationCodeRef={props.verificationCodeRef}
                        onCodeChange={props.onCodeChange}
                        codeBtnDisabled={props.codeBtnDisabled}
                    />
                }

                {/* RESET PASSWORD */}
                {props.currentStep === LOGIN_STEPS.STEP_4 &&
                    <Step4
                        formData={props.formData}
                        onChange={props.onChange}
                        loaderVisible={props.loaderVisible}
                        actionBtn={props.actionBtn}
                        pageTitle={props.pageTitle}
                        currentStep={props.currentStep}
                        changeStep={props.changeStep}
                        resetPassword1Icon={props.resetPassword1Icon}
                        resetPassword2Icon={props.resetPassword2Icon}
                        resetPasswordError={props.resetPasswordError}
                        passwordsNotMatchErrorMsg={props.passwordsNotMatchErrorMsg}
                    />
                }
        </AuthLayout>
        </>
    )
};

export default LoginContainer;
